export default __webpack_public_path__ + "static/media/hansindia.4ad01350.jpg";